const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

const ADS_LABELS = {
  call_click: process.env.REACT_APP_ADS_LABEL_CALL,
  sms_click: process.env.REACT_APP_ADS_LABEL_CALL,
  book_click: process.env.REACT_APP_ADS_LABEL_BOOK,
  callback_submit: process.env.REACT_APP_ADS_LABEL_CALLBACK,
  booking_completed: process.env.REACT_APP_ADS_LABEL_BOOKING_COMPLETED,
};

export function initAnalytics() {
  const ids = [GA4_ID, ADS_ID].filter(Boolean);
  if (!ids.length || window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  ids.forEach((id) => window.gtag("config", id, { send_page_view: false }));
  window.addEventListener("message", (e) => {
    if (!e.data || e.data.event !== "booking_completed") return;
    trackConversion("booking_completed");
  });
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
}

export function trackPageView(path) {
  trackEvent("page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

export function trackConversion(name, params = {}) {
  trackEvent(name, params);
  const label = ADS_LABELS[name];
  if (window.gtag && ADS_ID && label) {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, ...params });
  }
}
